import { KeyboardEvent } from 'react';

type IntegerProps = {
  min: number;
  max?: number;
  step?: number;
};

export const unsignedInteger = (props?: IntegerProps) => {
  const { min = 0, max = undefined, step = 1 } = props ? props : {};
  return {
    type: 'number',
    inputProps: {
      min,
      max,
      step,
    },
    onKeyDown: (event: KeyboardEvent<HTMLInputElement>) => {
      if (!/^[\d]+$/.test(event.key) && event.key.length === 1 && !event.ctrlKey && !event.altKey && !event.metaKey)
        event.preventDefault();
    },
  };
};
